import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/content")({
  component: Placeholder,
});

function Placeholder() {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-black/50">Admin module</p>
      <h2 className="text-2xl font-semibold tracking-tight text-black capitalize">content</h2>
      <p className="max-w-xl text-sm text-black/60">
        This module is being restored incrementally after the Stage 5 stabilization.
        The full experience will return in an upcoming stage.
      </p>
      <div className="mt-4 inline-flex w-fit items-center gap-2 border border-[#C6A15B]/40 bg-[#C6A15B]/5 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#8a6f2e]">
        content module coming next
      </div>
    </div>
  );
}
